export const SPOKEN_LANGUAGES = ['fr', 'en', 'de', 'it', 'es'] as const;

export type SpokenLanguage = (typeof SPOKEN_LANGUAGES)[number];

export const DEFAULT_LANGUAGES: SpokenLanguage[] = ['fr'];

/**
 * Filters the fixed SPOKEN_LANGUAGES list down to the ones present in `languages`,
 * keeping the canonical display order. Defensive against null/undefined so callers
 * don't each need their own `|| []` guard. Accepts `readonly string[]` (not just
 * `SpokenLanguage[]`) so it can take untyped API payloads directly without a cast:
 * the SPOKEN_LANGUAGES-side filter is what actually narrows the result to
 * SpokenLanguage.
 */
export const orderedSpokenLanguages = (
  languages: readonly string[] | null | undefined
): SpokenLanguage[] => {
  const present = languages || [];
  return SPOKEN_LANGUAGES.filter((code) => present.includes(code));
};
